import {
  Box,
  Button,
  Typography,
  useTheme,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  CircularProgress,
  TextField
} from "@mui/material";
import { tokens } from "../../theme";
import Header from "../../components/Header";
import { Sync } from "@mui/icons-material";
import { useState, useEffect } from "react";
import { useSelector } from 'react-redux';
import apiClient from '../../networking/axiosconfig';
import StatusCard from "../../components/StatusCard";
import DistrictStatusTable from "../../components/CategoryStatusTable";
import CompletedInspectionsTable from "../../components/CompletedOrdersTable";
import CompletedOrdersTable from "../../components/CompletedOrdersTable";
import CategoryStatusTable from "../../components/CategoryStatusTable";

const Dashboard = ({ callBack }) => {
  const [isLoading, setIsLoading] = useState(true);
  const { data: config } = useSelector((state) => state.config);
  const [orders, setOrders] = useState([]);
  const [categories, setCategories] = useState([]);
  const [time, setTime] = useState("Loading...");
  const [selectedStore, setSelectedStore] = useState("All");
  const [fromDate, setFromDate] = useState(new Date("2025-04-28"));
  const [toDate, setToDate] = useState(new Date());
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [selectedStatus, setSelectedStatus] = useState(null);

  const handleCategoryClick = (category) => {
    setSelectedCategory(category);
  };

  const handleStatusClick = (status) => {
    setSelectedStatus(status);
  };

  const handleOrderUpdate = () => {
    fetchData();
    };

  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  const dataMap = [
    { label: "Completed", count: orders.filter(v => v.status === "Completed").length, color: "success.main" },
    { label: "Processing", count: orders.filter(v => v.status === "Processing").length, color: "warning.main" },
    { label: "Pending", count: orders.filter(v => v.status === "Pending").length, color: "error.main" },
    { label: "Total", count: orders.length, color: "primary.main" }
  ];

  const fetchData = async () => {
    try {
      setIsLoading(true);
      const response = await apiClient.get(`${config.API_BASE_URL}/api/orders`);
      setOrders(response.data);
      const configResponse = await apiClient.get(`${config.API_BASE_URL}/api/categories`);
      setTime(`As of ${new Date().toLocaleDateString('en-IN', { day: '2-digit', month: '2-digit', year: 'numeric' }).replace(/\//g, '-')}
        ${new Date().toLocaleTimeString('en-IN', { hour: '2-digit', minute: '2-digit', hour12: true })}`);
      setIsLoading(false);
    } catch (error) {
      console.error("Error fetching MVU data:", error);
      setIsLoading(false);
      setOrders([]);
    }
  };

  useEffect(() => {
    if (callBack !== undefined) {
      callBack();
    }
    fetchData();
  }, [callBack, selectedStore, fromDate, toDate]);

  // Format dates for display in TextField
  const formatDate = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  const handleFromDateChange = (event) => {
    setFromDate(event.target.value ? new Date(event.target.value) : null);
  };

  const handleToDateChange = (event) => {
    setToDate(event.target.value ? new Date(event.target.value) : null);
  };

  return isLoading ? (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh"
      }}
    >
      <CircularProgress size={80} />
    </Box>
  ) : (
    <Box
      padding="20px"
      overflow="hidden"
      height="100vh"
      display="flex"
      flexDirection="column"
    >
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <Header title="DASHBOARD" subtitle={time} />

        <Box display="flex" alignItems="center" gap="10px">
          <TextField
            id="from-date"
            label="From Date"
            type="date"
            size="small"
            value={fromDate ? formatDate(fromDate) : ''}
            onChange={handleFromDateChange}
            InputLabelProps={{
              shrink: true,
            }}
          />
          <TextField
            id="to-date"
            label="To Date"
            type="date"
            size="small"
            value={toDate ? formatDate(toDate) : ''}
            onChange={handleToDateChange}
            InputLabelProps={{
              shrink: true,
            }}
          />
          <FormControl size="small">
            <InputLabel id="mvu-select-label">Select Store</InputLabel>
            <Select
              labelId="mvu-select-label"
              value={selectedStore}
              label="Select Store"
              onChange={(e) => setSelectedStore(e.target.value)}
              sx={{ minWidth: 120 }}
            >
              {config?.stores?.map((store) => (
                <MenuItem key={store.Store_Name} value={store.Store_Name}>
                  {store.Store_Name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          <Button
            onClick={fetchData}
            sx={{
              backgroundColor: colors.blueAccent[700],
              color: colors.grey[100],
              fontSize: "14px",
              fontWeight: "600",
              padding: "10px 20px",
            }}
          >
            <Sync sx={{ mr: "10px" }} />
            Refresh Data
          </Button>
        </Box>
      </Box>
      <Box
        overflow="hidden"
        flex={1}
        display="flex"
        gap="20px"
        marginTop="20px"
      >
        {/* Left Column */}
        <Box
          sx={{
            flex: '0 0 100%', // Set flex basis to 50%
            maxWidth: '100%',    // Add max-width to ensure it doesn't exceed 50%
            display: "flex",
            flexDirection: "column",
            gap: "20px",
            height: "100%"
          }}
        >
          <StatusCard title={selectedStore} data={dataMap} />
          <CompletedOrdersTable orders={orders} selectedCategory={selectedCategory} selectedStatus={selectedStatus} onOrderUpdate={handleOrderUpdate} selectedStore={selectedStore}/>
        </Box>

        {/* Right Column */}
        {/* <Box
          sx={{
            flex: '0 0 50%', // Set flex basis to 50%
             maxWidth: '50%',   // Add max-width
            display: "flex",
            flexDirection: "column",
            gap: "20px",
            height: "100%",
            overflowY: "auto"
          }}
        >
          <CategoryStatusTable categories={categories} onCategoryClick={handleCategoryClick} onStatusClick={handleStatusClick} />
        </Box> */}
      </Box>

    </Box>
  );
};

export default Dashboard;
